export const setSelectedAssociationID = (id) => ({
    type: 'SET_SELECTED_ASSOCIATION_ID',
    id
});

export const setSelectedAssociation = (association) => ({
    type: 'SET_SELECTED_ASSOCIATION',
    association
});